module.exports = __webpack_public_path__ + "77141498e9e3578c2e4333f9101ae05c.jpg";


//////////////////
// WEBPACK FOOTER
// ./ngapp/images/pic2.jpg
// module id = 272
// module chunks = 0